import React from 'react';
import { Link } from 'react-router-dom';

function ApprochCard({ thumbnail, icon, heading, text, btnText, pageLink }) {
    return (
        <>
            <div className="col-md-6 col-xl-4 col-12">
                <div className="single-approch-card">
                    <div
                        className="card-thumb bg-cover"
                        style={{
                            backgroundImage: `url(${thumbnail})`,
                        }}
                    />
                    <div className="content">
                        <div className="case-cat">                      
                        </div>
                        <h3>
                            <Link to={pageLink}>{heading}</Link>
                        </h3>
                        <p>{text}</p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ApprochCard;
